module.exports = __webpack_public_path__ + "static/media/rooney-mara-win.ff06a22f.jpg";